import { store } from "./store";

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppGetState = () => RootState;

export interface ThunkAPI {
  dispatch: AppDispatch;
  getState: AppGetState;
  state: RootState;
}

export enum StatusState {
  IDLE = "idle",
  LOADING = "loading",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export enum ActionType {
  CONFIRM = "confirm",
  DECLINE = "decline",
  NONE = "none",
}

export enum LoadingState {
  NONE = "none",
  CONFIRMING = "confirming",
  DECLINING = "declining",
}